module.exports = __webpack_public_path__ + "img/explanation2.9ad710e3.svg";